import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';

import { Icon } from '~/components';
import downloadFile from '~/utils/downloadFile';
import * as S from './styles';

export default function Card({ id, name, thumbnail, isPrivate }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  return (
    <S.Container key={v4()}>
      <S.Label>{t('report')}</S.Label>
      <S.Title>{name}</S.Title>
      <S.DownloadButtonContainer>
        <S.DownloadButton
          onClick={() => downloadFile(id, setLoading, isPrivate)}
        >
          {loading ? (
            <S.Spinner size={32} />
          ) : (
            <Icon name="download" size={22} color="white" />
          )}
        </S.DownloadButton>
      </S.DownloadButtonContainer>
      <S.Preview src={`data:image/jpeg;base64,${thumbnail}`} />
    </S.Container>
  );
}

Card.defaultProps = {
  isPrivate: false,
};

Card.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  isPrivate: PropTypes.bool,
};
